import React, { useState, useEffect } from 'react'
import {
  Row, Col,
  Card, CardBody,
  Input, Label, Button,
  FormGroup, FormFeedback
} from 'reactstrap'
import ReactHTMLParser from 'react-html-parser'
import _ from 'lodash'

import Lang from 'Lang/General'

const MultilingualInput = ({
  customStyle,
  label,
  selectedLanguage,
  value,
  valueName,
  objectName,
  id,
  parent,
  parentName,
  maxLength,
  onChangeValue,
  disabled,
  isRequired,
  isTextArea,
  style,
  contentPlaceholdersLabel,
  contentPlaceholders,
  showCharCount,
  invalid,
  hideMaxLengthLabel,
  defaultShowLang = false
}) => {
  const [ buttonLang, updateButtonLang ] = useState( selectedLanguage )
  const [ showLangBar, updateShowLangBar ] = useState( false )
  const [ charsLeft, updateCharsLeft ] = useState( {} )

  const langList = [ 'en', 'de', 'nl', 'it' ]

  useEffect( () => {
    if( maxLength ) {
      updateCharsLeft({
        en: maxLength - value[ 'en' ].length,
        de: maxLength - value[ 'de' ].length,
        it: maxLength - value[ 'it' ].length,
        nl: maxLength - value[ 'nl' ].length
      })
    }
  }, [ maxLength ] )

  const updateContent = val => {
    let tmpParent = _.cloneDeep( parent )

    if( typeof objectName !== 'undefined' && typeof id === 'undefined' ) {
      findObjectAndPatch( tmpParent, val )
    } else if ( objectName ){
      findArrayAndPatch( tmpParent, val )
    } else if ( valueName ) {
      tmpParent[ valueName ][ buttonLang ] = val
    } else {
      tmpParent[ buttonLang ] = val
    }
    onChangeValue( parentName, tmpParent )
  }

  const findArrayAndPatch = ( data, result ) => {
    Object.keys( data ).map( item => {
      if( item === objectName ){
        let tmpIndex = _.findIndex( data[ objectName ], { id: id } )
        data[ objectName ][ tmpIndex ][ valueName ][ buttonLang ] = result
        return data
      } else {
        if( data[ item ] && typeof data[ item ] !== 'string' && Object.keys( data[ item ] ).length > 0 ){
          findArrayAndPatch( data[ item ], result )
        }
      }
    })
    return data
  }

  const findObjectAndPatch = ( data, result ) => {
    Object.keys( data ).map( item => {
      if( item === objectName.toString() ){
        let tmpData = _.cloneDeep( data[ item ] )
        tmpData[ valueName ][ buttonLang ] = result
        data[ item ] = tmpData
        return data
      } else {
        if( 
          data[ item ] && 
          typeof data[ item ] !== 'string' && 
          Object.keys( data[ item ] ).length > 0 &&
          !data[ item ][ '_isAMomentObject' ]
        ){
          findObjectAndPatch( data[ item ], result )
        }
      }
    })
    return data
  }

  return(
    <FormGroup style={{ ... customStyle }}>
      <Row
        className='mb-2'
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: label ? "space-between" : "flex-end" }} >
        {
          label && <Col sm={ 6 } >
            <Label className={ `mb-0${ isRequired ? ' is-required' : '' }` } >{ ReactHTMLParser( label ) }</Label>
          </Col>
        }
        {
          contentPlaceholders && (
            <Col sm={ 12 } >
              <Card className="my-2">
                <CardBody>
                  {
                    contentPlaceholdersLabel ? (
                      <p>{ contentPlaceholdersLabel }:</p>
                    ) : (
                      <p>{ `${ Lang[ 'FOLLOWING_ARE_PLACEHOLDERS_AVAILABLE_FOR' ][ selectedLanguage ] }` }{ ReactHTMLParser( label.toLowerCase() ) }:</p>
                    )
                  }
                  <ul>
                    {
                      _.map( contentPlaceholders, ( value, key ) => (
                        <li>{ `${ Lang[ key ][ selectedLanguage ] }: ${ value }` }</li>
                      ))
                    }
                  </ul>
                </CardBody>
              </Card>
            </Col>
          )
        }
        {
          (defaultShowLang || showLangBar) && (
            <div
              style={{
                padding: "0 15px",
                width: "max-content" }} >
              {
                langList.map( lang => <Button
                  type='button'
                  className='mr-1 mb-1'
                  color={ lang === buttonLang ? 'success' : 'primary' }
                  onClick={ () => updateButtonLang( lang ) }
                  onMouseDown={ e => e.preventDefault() } >
                  { lang }</Button> )
              }
            </div>
          )
        }
      </Row>
      <Input
        type={ isTextArea ? 'textarea' : 'text' }
        disabled={ disabled }
        value={ value ? value[ buttonLang ] : '' }
        onChange={ e => {
          updateContent( e.target.value )
          if( maxLength ) {
            let tmp = _.cloneDeep( charsLeft )
            tmp[ buttonLang ] = maxLength - e.target.value.length
            updateCharsLeft( tmp )
          }
        }}
        onClick={ () => updateShowLangBar( true ) }
        onBlur={ () => updateShowLangBar( false ) }
        style={ style && style }
        maxlength={ maxLength } 
        invalid={ invalid }
      />
      <FormFeedback>{ invalid }</FormFeedback>
      {(!hideMaxLengthLabel && maxLength) && (
        <Label>
          { `${ Lang[ 'REMAINING_CHARACTERS' ][ selectedLanguage ] } ${ charsLeft[ buttonLang ] }` }
        </Label>
      )}
      { showCharCount && <Label>{ `${ Lang[ 'NO_OF_CHARACTERS' ][ selectedLanguage ] }: ${ value[ buttonLang ].length }` }</Label> }
    </FormGroup>
  )
}

export default MultilingualInput
